export default __webpack_public_path__ + "TeddyGIGANTINO.f7bafea.png";